import React from "react";
import DialogMedium from "../DialogMedium";
import { Button, Grid, Typography } from "@mui/material";
import TextField from "../FormFields/TextField";
import { useForm } from "react-hook-form";
import { apiSollar } from "../../services/axios";
import Cookies from "js-cookie";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import {
//   closePopup,
//   loadRequest,
// } from "../../store/ducks/digitalSignature/action";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

interface IConfirmExitProps {
  open: boolean;
  handleClose?: () => void;
}

function ConfirmExit({ open, handleClose }: IConfirmExitProps) {
  const userState = useSelector((state: ApplicationState) => state.users);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const validations = yup.object().shape({
    password: yup.string().required("É requerido"),
  });

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      password: "",
    },
    resolver: yupResolver(validations),
  });

  function handleCancel() {
    return;
  }

  return (
    <>
      <DialogMedium
        title={"Existem documentos que não foram finalizados"}
        open={open}
        fullWidth={true}
        maxWidth="sm"
        handleClose={() => {
          !!handleClose && handleClose();
          // dispatch(closePopup());
        }}
      >
        <Grid
          container
          spacing={2}
          component="form"
          onSubmit={handleSubmit((values) => {
            reset();
          })}
        >
          <Grid item xs={12} mb={2}>
            <Typography color="primary">
              Você perderá todas as alterações não salvas. Deseja voltar para a lista?
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" color="error" variant="contained"
              onClick={() => {
                navigate(`/telemedicine/${params.attendance_type}`);
              }}
            >
              Sim, quero sair
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                handleCancel();
                !!handleClose && handleClose();
                // dispatch(closePopup());
              }}
              color="primary"
              variant="contained"
            >
              Não, continuar editando
            </Button>
          </Grid>
        </Grid>
      </DialogMedium>
    </>
  );
}

export default ConfirmExit;
